import { FONTSIZE } from "../../constants";
import { User } from "../../types";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { THEME_COLORS } from "../themes/DarkLight";
import emitter, { EmitterEvents } from "../utils/eventsEmitter";
import ProfilePictureDisplayer from "./ProfilePictureDisplayer";
import Text from "./ThemedText";

function UserHorizontalCard({ userData }: { userData: User }) {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();

  return (
    <div
      onClick={() => {
        emitter.emit(EmitterEvents.BOTTOM_SHEET_DISPLAY, {
          modal: { name: "userModal", modalData: { user: userData } },
        });
      }}
      className={`p-3 flex flex-col items-center justify-center rounded-2xl min-w-[120px] max-w-[120px] overflow-hidden gap-3 cursor-pointer transition-all duration-200 border ${
        theme === "dark"
          ? "bg-gray-800 border-gray-700 hover:border-gray-600"
          : "bg-white border-gray-200 hover:border-gray-300 shadow-sm"
      }`}
    >
      {/* Profile Picture */}
      <div className="pointer-events-none">
        <ProfilePictureDisplayer
          margin={"0"}
          userUid={userData["id"] as any}
          height="70px"
          onClick={() => {}}
          profilePicture={
            userData["profileImage"] ??
            "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
          }
          userAccountType={"personal"}
          width="70px"
        />
      </div>

      {/* User Info */}
      <div className="flex-1 w-full flex flex-col items-center justify-center gap-1">
        <Text
          text={userData["username"]}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: FONTSIZE.TERTIARY,
            color: THEME_COLORS[theme].inverse_theme,
            width: "100px",
          }}
        />
        <p
          className={`whitespace-nowrap overflow-hidden text-ellipsis text-xs w-[100px] text-center ${
            theme === "dark" ? "text-gray-500" : "text-gray-400"
          }`}
        >
          @{userData["username"]}
        </p>
      </div>

      {/* View Button */}
      <div className="w-full flex-grow-0">
        <div
          className={`py-2 px-4 flex items-center justify-center w-full rounded-xl text-sm font-medium transition-colors duration-200 ${
            theme === "dark"
              ? "bg-blue-600 hover:bg-blue-700 text-white"
              : "bg-blue-500 hover:bg-blue-600 text-white"
          }`}
        >
          <p>{getTranslationText("view")}</p>
        </div>
      </div>
    </div>
  );
}

export default UserHorizontalCard;